// Must be first: Faro hooks fetch/XHR and captures early errors at module-eval
// time, so it has to initialize before any other side-effecting import runs.
import './faro';
import 'bootstrap/dist/css/bootstrap.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import App from './App';
import './index.scss';

const container = document.getElementById('root')!;
const root = ReactDOM.createRoot(container);

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/*" element={<App />} />
    </Routes>
  </BrowserRouter>,
);
